/**
 * ResourcesPreviousAndNext functionality
 * @class
 */
export default class ResourcesPreviousAndNext {
    /**
     * @constructor
     * @param {HTMLElement} element The ResourcesPreviousAndNext root element
     */
    constructor(element) {
        var _a, _b, _c, _d, _e;
        this.el = element;
        this.components = {
            previousBtn: this.el.querySelector('[data-component="ResourcesPreviousButton"]'),
            nextBtn: this.el.querySelector('[data-component="ResourcesNextButton"]')
        };
        const searchParams = new URLSearchParams(window.location.search);
        const urlBase = window.location.pathname;
        const searchTerm = searchParams.get("searchTerm") != null ? `&searchTerm=${searchParams.get("searchTerm")}` : "";
        const resourceTypes = searchParams.get("resourceTypes") != null ? `&resourceTypes=${searchParams.get("resourceTypes")}` : "";
        const filters = searchParams.get("filters") != null ? `&filters=${searchParams.get("filters")}` : "";
        const orderby = searchParams.get("orderby") != null ? `&orderby=${searchParams.get("orderby")}` : "";
        const pageSearchParams = searchParams.get("page");
        if (pageSearchParams === null || pageSearchParams === "1") {
            (_a = this.components.previousBtn) === null || _a === void 0 ? void 0 : _a.classList.add("isHidden");
            this.el.classList.add("resources-pagination-and-sort__previous-and-next-buttons--without-previous-button");
            const nextPage = `${urlBase}?page=2${searchTerm}${filters}${resourceTypes}${orderby}`;
            (_b = this.components.nextBtn) === null || _b === void 0 ? void 0 : _b.setAttribute("href", nextPage);
        }
        else {
            (_c = this.components.previousBtn) === null || _c === void 0 ? void 0 : _c.classList.remove("isHidden");
            this.el.classList.remove("resources-pagination-and-sort__previous-and-next-buttons--without-previous-button");
            const previousPageNumber = Number(pageSearchParams) - 1;
            const previousPage = `${urlBase}?page=${previousPageNumber}${searchTerm}${filters}${resourceTypes}${orderby}`;
            (_d = this.components.previousBtn) === null || _d === void 0 ? void 0 : _d.setAttribute("href", previousPage);
            const nextPageNumber = Number(pageSearchParams) + 1;
            const nextPage = `${urlBase}?page=${nextPageNumber}${searchTerm}${filters}${resourceTypes}${orderby}`;
            (_e = this.components.nextBtn) === null || _e === void 0 ? void 0 : _e.setAttribute("href", nextPage);
        }
        //console.log('ResourcesPreviousAndNext', this);
    }
    /**
     * Creates new instances of IResourcesPreviousAndNextUtils for each `[data-component="ResourcesPreviousAndNext"]` element
     */
    static init() {
        const ResourcesPreviousAndNextEl = document.querySelector('[data-component="ResourcesPreviousAndNext"]');
        if (ResourcesPreviousAndNextEl) {
            const ResourcesPreviousAndNextUtil = new ResourcesPreviousAndNext(ResourcesPreviousAndNextEl);
        }
    }
}
